/*globals reApplyB2bEnabled:true */

angular.module('b2bRegistrationFlowBundle')
    .controller('CompanyRegistrationController', ["$scope", "$http", "$window", "sdLocalStorageHelper", "$filter", "stepsConfig", "$timeout", "$cookies", "skyapi", "ConvertExperienceService", function ($scope, $http, $window, sdLocalStorageHelper, $filter,
                                                           stepsConfig, $timeout, $cookies, skyapi, ConvertExperienceService) {

        $scope.formStatus = {};
        $scope.data = {
            'prename': '',
            'name': '',
            'contact_email': '',
            'filters': [],
            'promo_codes': '',
            'area_tool': '',
            'radius_postcode': '',
            'radius': '',
            'regions': [],
            'subRegions': [],
            'types': [],
        };

        $scope.userData = {};
        $scope.data = sdLocalStorageHelper.get('b2bFormDetails', $scope.data);

        $scope.$watchCollection('data', function () {
            sdLocalStorageHelper.set('b2bFormDetails', $scope.data);
        });

        $scope.clearUserData = function () {
            $scope.userData = {};
        };

        $scope.stepsData = {
            version: 1, // 'Versioning added to avoid mixed structure of local storage when migrating between structures'
            areaSelectionSummary: {},
            allChildrenUnchecked: true,
            areas_panel_type: ''
        };

        $scope.hintsState = {
            'lead-types': {
                'lead-type': false
            },
            'working-areas': {
                'areas_panel_type': false
            },
            'company-details': {
                'data.company_number': false,
                'data.contact_email': false,
                'data.contact_telephone': false
            }
        };

        $scope.steps = stepsConfig.home;
        $scope.submitUrl = skyapi + '/companies/create-company';

        $scope.submitCompanyRegistration = function () {
            var params = angular.copy($scope.data);

            var cookieMap = {
                'b2b_utm_converted': 'b2b_utm_converted',
                'b2b_utm_original': 'b2b_utm_original',
                'b2c_utm_original': 'b2c_utm_original',
                'gclid': 'gclid',
                'gbraid': 'gbraid',
                'wbraid': 'wbraid',
                // https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/fbp-and-fbc
                '_fbc': '_fbc',
                '_fbp': '_fbp',
            };

            var cookieParams = {};
            Object.entries($cookies.getAll()).map(function (arr) {
                if (typeof cookieMap[arr[0]] != 'undefined') {
                    cookieParams[cookieMap[arr[0]]] = arr[1];
                }
            });

            const authcodeElement = document.body.querySelector('[data-authcode]');
            params.authcode = authcodeElement ? authcodeElement.getAttribute('data-authcode') : null;
            angular.extend(params, {
                'callback_': 'JSON_CALLBACK',
                'method_': 'jsonp',
            }, $scope.data, cookieParams, getCookieConsentData());

            if ($scope.countryIso === 'BE') {
                params.regions = cleanUpBERegionIds(params);
            }

            params.businessUnit = document.body.getAttribute('data-businessUnit');
            angular.extend(params, getExperimentData());

            submitForm(params);
        };

        function getCookieConsentData() {
            if (!window.skyComponents || !window.skyComponents.usercentricsService) {
                return {};
            }

            if (!window.skyComponents.usercentricsService.isInitialized()) {
                console.warn('"usercentricsService" is not initialized.');
                return {};
            }

            return {
                'cookie-consent': {
                    'google-ads': window.skyComponents.usercentricsService.getCookieConsentData('Google Ads'),
                    'facebook-pixel': window.skyComponents.usercentricsService.getCookieConsentData('Facebook Pixel')
                }
            };
        }

        function cleanUpBERegionIds(params) {
            return params.regions
                .filter(function (region) {
                    return region.indexOf('_') > -1;
                })
                .map(function (region) {
                    return region.split('_')[1];
                });
        }

        function enhanceDataLayer(params, createCompanyResponse) {

            let dataLayerObject = {
                event: "form_success",
                form_name: "business_registration",
                eid_sha256: createCompanyResponse.emailHash,
                form_id: document.querySelector('[data-b2b-form-authcode]').getAttribute('data-b2b-form-authcode'),
                company: {
                    company_id: createCompanyResponse.companyId,
                    company_name: params.companyname,
                    business_type: params.business_type,
                    number_of_employees: params.number_of_employees,
                    contact_email: params.contact_email,
                    contact_telephone: params.contact_telephone,
                    contact_website: params.contact_website,
                    product_group: createCompanyResponse.categories,
                },
                business_unit: params.businessUnit,
                company_address: {
                    country_iso: createCompanyResponse.address.country_iso,
                },
                lead_details: {
                    targeting_area: {
                        type: params.area_tool,
                        unit_system: createCompanyResponse.unit_system,
                        radius_value: 'N/A',
                        radius_location: 'N/A',
                    }
                },
                form_step: $scope.steps.length,
                form_total_steps: $scope.steps.length,
                form_step_name: $scope.steps[$scope.steps.length - 1].title,
            };

            let abVersion = document.body.getAttribute('data-ab');
            if (abVersion) {
                dataLayerObject.ab_test_variant = abVersion;
            }

            if (params.area_tool === 'radius') {
                dataLayerObject.lead_details.targeting_area.radius_value = params.radius;
                dataLayerObject.lead_details.targeting_area.radius_location = params.location.label;
            }

            for (const [key, value] of Object.entries(params)) {
                if (key.startsWith('address_')) {
                    dataLayerObject.company_address[key] = value;
                }
            }

            if (params.businessUnit === 'move') {
                dataLayerObject.lead_details.removals_interest = createCompanyResponse.includedTypes.movers;
            }

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(dataLayerObject);

            if (window.localStorage.getItem('ga-debug')) {
                console.info('GA event pushed:', dataLayerObject);
            }
        }

        function submitForm(params) {
            if (typeof reApplyB2bEnabled !== 'undefined' && reApplyB2bEnabled) {
                $scope.formStatus.submitting = true;
                $scope.checkDuplicateCompany().success(function (response) {
                    if (response.email && response.userHashId && response.companyHashId) {
                        $scope.userData.duplicateEmail = response.email;
                        $http.post('/companies/duplicate-registration', {'userHashId': response.userHashId, 'companyHashId': response.companyHashId}).success(function () {
                            $scope.formStatus.submitting = false;
                        })
                    } else if (response.email) {
                        $scope.userData.duplicateEmailExists = true;
                        $scope.formStatus.submitting = false;
                    } else {
                        $scope.createCompany(params, enhanceDataLayer);
                    }
                })
            } else {
                $scope.createCompany(params, enhanceDataLayer);
            }
        }

        $scope.createCompany = function (params, enhanceDataLayerCallback) {

            $scope.formStatus.submitting = true;
            if (!params.types || params.types.length === 0) {
                params.types = Object.values(params.multipleTypes).flat();
            }

            $http.post($scope.submitUrl, params).success(function (data, status) {
                if (status < 200 && status >= 300) {
                    handleError(params);
                    return;
                }
                enhanceDataLayerCallback(params, data);
                $scope.handleCompanyCreated(params, data);
            })
        }

        $scope.handleCompanyCreated = function (params, data) {
            var dataLayerDelay = 500;
            setTimeout(function () {
                params.businessUnit === 'home' ? $window.location = data.user_activation_url : $window.location = $scope.successUrl;
            }, dataLayerDelay);
        }

        /**
         * Retries to send the form submission once. Shows an error message to the user if the second attempt fails.
         */
        function handleError(params) {
            $scope.submitErrorCount = $scope.submitErrorCount + 1;
            switch ($scope.submitErrorCount) {
                case 1: // Retry..
                    submitForm(params);
                    break;
                case 2: // Warn user
                default:
                    $scope.formStatus.submitting = false;
                    $scope.submitErrorCount = 0;
                    window.alert('We are unable to send your quote request at this time. Please try again in a few minutes.');
                    break;
            }
        }

        $scope.checkDuplicateCompany = function () {
            let email = $scope.data.contact_email;
            let companyNumber = $scope.data.company_number || null;
            let phoneNumber = $scope.data.contact_telephone;
            return $http.get('/companies/get-duplicate-account-data?' +
                'email=' + encodeURIComponent(email) +
                '&companyNumber=' + encodeURIComponent(companyNumber) +
                '&phoneNumber=' + encodeURIComponent(phoneNumber) +
                '&countryIso=' + $scope.countryIso);
        }

        $scope.toggleHint = function (step, question) {
            $scope.hintsState[step][question] = !$scope.hintsState[step][question];
            if ($scope.hintsState[step][question]) {
                $timeout(() => {
                    document.body.addEventListener('click', () => {
                        $scope.hintsState[step][question] = false;
                        $scope.$apply()
                    }, {once: true});
                }, 1);
            }
        };

        function getExperimentData() {
            let data = {};

            try {
                let ab_test = document.body.dataset.ab;
                let ab_test_optimize_id = document.body.dataset.abTestOptimizeId;
                let optimizeVariantIndex = undefined;

                if (window.google_optimize && ab_test_optimize_id) {
                    optimizeVariantIndex = window.google_optimize.get(ab_test_optimize_id);
                    if (typeof optimizeVariantIndex !== 'undefined') {
                        const active_variant = String.fromCharCode(optimizeVariantIndex + 64 + 1).toLowerCase();
                        if (active_variant !== document.body.dataset.abTestVersion.toLowerCase()) {
                            console.error(`Incorrect google optimize version detected. Expected(optimize): ${active_variant}, actual: ${document.body.dataset.abTestVersion}`);
                        }
                    }
                }
                if (ab_test) {
                    data['ab_test'] = ab_test;
                }

                if (typeof optimizeVariantIndex !== 'undefined') {
                    data['ab_test_optimize_id'] = ab_test_optimize_id;
                }

                const convertExperiences = ConvertExperienceService.getAllExperiences();
                if (convertExperiences.length) {
                    data['convert_experiences'] = convertExperiences;
                }

            } catch (error) {
                console.error('Error when getting experiment data', error);
            }
            return data;
        }

        $scope.resetCompanyNumber = function () {
            $scope.data.company_number = null;
            $scope.data.company_number2 = null;
        }
    }]);
